import axios from 'axios';
import setQueryString from 'set-query-string';

let listFilters = document.querySelectorAll('[data-list-filter]');
const loadingClassName = 'is-loading';
const refreshingClassName = 'is-refreshing';
const enteringClassName = 'is-entering';
const entryDelayStep = 60;
const entryAnimationDuration = 360;

function setLoadingState(listForm, articleList, trigger, isLoading) {
    const articleListContainer = articleList.parentElement;

    articleList.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    articleListContainer.classList.toggle(loadingClassName, isLoading);

    if (isLoading) {
        listForm.dataset.loading = 'true';
    } else {
        delete listForm.dataset.loading;
    }

    if (trigger && trigger.name === 'index') {
        trigger.classList.toggle(loadingClassName, isLoading);

        if (isLoading) {
            trigger.setAttribute('disabled', 'disabled');
            trigger.setAttribute('aria-disabled', 'true');
        } else {
            trigger.removeAttribute('disabled');
            trigger.removeAttribute('aria-disabled');
        }
    }
}

function renderArticleList(articleList, markup, shouldAppend) {
    const resultRange = document.createRange();
    resultRange.selectNodeContents(articleList);

    const renderedResults = resultRange.createContextualFragment(markup || '');
    const newElements = Array.from(renderedResults.children);

    newElements.forEach((element, index) => {
        element.classList.add(enteringClassName);
        element.style.setProperty('--article-list-entry-delay', `${index * entryDelayStep}ms`);
    });

    if (!shouldAppend) {
        articleList.innerHTML = '';
    }

    articleList.appendChild(renderedResults);

    window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
            newElements.forEach(element => {
                element.classList.remove(enteringClassName);
            });
        });
    });

    window.setTimeout(() => {
        newElements.forEach(element => {
            element.style.removeProperty('--article-list-entry-delay');
        });
    }, entryAnimationDuration + (newElements.length * entryDelayStep));
}

listFilters.forEach(listForm => {
    const API = './GetContent';
    const articleList = document.getElementById(listForm.dataset['listFilter']);

    function fetchArticles(event) {
        const articleList = document.getElementById(this.dataset['listFilter']);
        let formData = new FormData(listForm);
        let trigger = document.activeElement;

        if (trigger === document.body) {
            // if Safari is trying to trick us by setting activeElement to the body, get the index button
            trigger = listForm.querySelector('[name="index"]');
        }

        const isPaginationRequest = trigger && trigger.name === 'index';

        if (event.type === 'submit') {
            event.preventDefault();
        }
        if (event.type === 'change' && event.target.validity.valid !== true) {
            return;
        }
        if (listForm.dataset.loading === 'true') {
            return;
        }

        const requestParams = {};
        for (const [key, value] of formData.entries()) {
            requestParams[key] = value;
        }
        if (isPaginationRequest) {
            if (articleList.dataset.page) {
                articleList.dataset.page++;
            }
            else {
                articleList.dataset.page = 1;
            }
            requestParams['index'] = articleList.dataset.page;
        }

        const currentLastResult = articleList.lastElementChild;
        const itemCountLabel = listForm.querySelector('[data-list-filter-count] > em');
        const itemCountElement = listForm.querySelector('[data-list-filter-count] > b');
        const itemCountParent = listForm.querySelector('[data-list-filter-count]');
        const indexButton = listForm.elements['index'];

        setLoadingState(listForm, articleList, trigger, true);

        if (!isPaginationRequest) {
            articleList.classList.add(refreshingClassName);
        }

        axios.get(API,
            {
                params: requestParams
            }).then(response => {
                if (isPaginationRequest) {
                    renderArticleList(articleList, response.data.result.result, true);
                } else {
                    renderArticleList(articleList, response.data.result.result, false);
                    articleList.dataset.page = 0;
                    if (response.data.itemCount !== undefined && itemCountElement) {
                        itemCountElement.innerText = response.data.itemCount;
                        itemCountLabel.innerText = requestParams['q'];
                    }
                }

                articleList.parentElement.removeAttribute('hidden');

                if (itemCountParent) {
                    itemCountParent.removeAttribute('hidden');
                }

                if (indexButton) {
                    indexButton.value = parseInt(articleList.dataset.page, 10) + 1;
                }

                if (!response.data.last && indexButton) {
                    indexButton.removeAttribute('hidden');
                }

                if (response.data.last) {
                    articleList.parentElement.classList.add('is-done');
                } else {
                    articleList.parentElement.classList.remove('is-done');
                }

                if (currentLastResult && currentLastResult.nextElementSibling) {
                    const nextLink = currentLastResult.nextElementSibling.querySelector('a');

                    if (nextLink) {
                        nextLink.focus();
                    }
                }

                const facetsFilter = document.getElementById('facets-filter');

                if (response.data.facets) {
                    for (let facet in response.data.facets) {
                        if (response.data.facets.hasOwnProperty(facet)) {
                            const facetElement = document.querySelector(`[name="${facet}"]`);

                            if (facetElement) {
                                const newOptions = response.data.facets[facet];
                                const currentOptions = facetElement.options;

                                if (newOptions) {
                                    facetElement.removeAttribute('disabled');

                                    const optionElements = [];

                                    Array.prototype.forEach.call(currentOptions,
                                        currentOption => {
                                            if (!newOptions.find(option => option.value === currentOption.value)) {
                                                currentOption.setAttribute('disabled', true);
                                            }
                                        });

                                    newOptions.forEach(facet => {
                                        let existingOption =
                                            facetElement.querySelector(`option[value="${facet.value}"]`);
                                        if (!existingOption) {
                                            const option = document.createElement('option');
                                            option.value = facet.value;
                                            option.innerText = facet.text;
                                            optionElements.push(option);
                                        } else {
                                            existingOption.removeAttribute('disabled', true);
                                        }
                                    });
                                    facetElement.append(...optionElements);

                                    let sortedOptions = Array.apply(null, facetElement.options);

                                    sortedOptions.sort((a, b) => {
                                        return a.text !== b.text ? a.text < b.text ? -1 : 1 : 0;
                                    });

                                    sortedOptions.forEach((option, index) => {
                                        facetElement.options[index] = new Option(option.text,
                                            option.value,
                                            option.defaultSelected,
                                            option.selected);
                                        facetElement.options[index].disabled = option.disabled;
                                    });
                                } else {
                                    facetElement.setAttribute('disabled', true);
                                }

                                facetElement.parentNode.removeAttribute('hidden');
                               
                            }
                        }
                    }
                    facetsFilter.removeAttribute('hidden');
                }

                setQueryString(requestParams);

            }).catch(error => {
                return false;
            }).then(() => {
                articleList.classList.remove(refreshingClassName);
                setLoadingState(listForm, articleList, trigger, false);
            });
    }

    if (articleList) {
        listForm.addEventListener('submit', fetchArticles, false);
        listForm.addEventListener('change', event => {

            if (!event.currentTarget.checkValidity()) {
                [...event.currentTarget.elements].some(element => {
                    if (!element.validity.valid) {
                        if ('reportValidity' in element) {
                            element.reportValidity();
                        } else {
                            element.focus();
                        }
                        return true;
                    }
                    return false;
                });
            } else {
                const submitEvent = document.createEvent('Event');
                submitEvent.initEvent('submit', true, true);
                let eventTrigger =
                    event.currentTarget.querySelector('input[type="submit"], button:not([type="button"])');
                if (eventTrigger) {
                    eventTrigger.click();
                    event.target.focus();
                } else {
                    event.currentTarget.dispatchEvent(submitEvent);
                }
            }
        });
    }
});